package com.patronat.top.client.data.venues

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.dto.SavedVenueIdsResponse
import com.patronat.top.dto.VenueFilterRequest
import com.patronat.top.dto.VenueListResponse
import com.patronat.top.dto.VenueResponse
import com.patronat.top.dto.VenueServiceSuggestionsResponse

class ClientVenuesRepository(
    private val remoteDataSource: ClientVenuesRemoteDataSource
) {
    suspend fun getVenues(request: VenueFilterRequest): DomainResult<VenueListResponse> {
        return remoteDataSource.filterVenues(request).asDomainResult { it }
    }

    suspend fun getVenueById(venueId: String): DomainResult<VenueResponse> {
        return remoteDataSource.getVenueById(venueId).asDomainResult { it }
    }

    suspend fun suggestServices(query: String): DomainResult<VenueServiceSuggestionsResponse> {
        return remoteDataSource.suggestServices(query).asDomainResult { it }
    }

    suspend fun getSavedVenueIds(): DomainResult<SavedVenueIdsResponse> {
        return remoteDataSource.getSavedVenueIds().asDomainResult { it }
    }

    suspend fun getSavedVenues(
        page: Int,
        pageSize: Int,
        query: String?
    ): DomainResult<VenueListResponse> {
        return remoteDataSource.getSavedVenues(page, pageSize, query).asDomainResult { it }
    }

    suspend fun saveVenue(venueId: String): DomainResult<Unit> {
        return remoteDataSource.saveVenue(venueId).asDomainResult { it }
    }

    suspend fun unsaveVenue(venueId: String): DomainResult<Unit> {
        return remoteDataSource.unsaveVenue(venueId).asDomainResult { it }
    }
}
